import { motion } from 'framer-motion';

const steps = [
  {
    number: '1',
    title: 'Create Your Workspace',
    description: 'Sign up free at BoardChat.io',
  },
  {
    number: '2',
    title: 'Set Up Your Boards',
    description: 'Add tasks, columns, and teammates',
  },
  {
    number: '3',
    title: 'Collaborate Effortlessly',
    description: 'Chat, assign, and track progress in real time',
  },
];

export const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-20 bg-white" data-testid="how-it-works-section">
      <div className="container-main">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <span className="section-label section-label-orange">GETTING STARTED</span>
          <h2 className="text-3xl sm:text-4xl lg:text-[42px] font-bold text-[#1E293B] leading-tight">
            Get Started in 3 Simple Steps
          </h2>
        </motion.div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto mb-12">
          {steps.map((step, index) => (
            <motion.div
              key={step.number}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.15 }}
              className="text-center relative"
              data-testid={`step-${step.number}`}
            >
              {/* Connector line for desktop */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-6 left-[60%] w-[80%] h-[2px] bg-gray-200" />
              )}

              {/* Step number */}
              <div className="step-number mx-auto mb-4">
                {step.number}
              </div>

              {/* Content */}
              <h3 className="text-lg font-semibold text-[#1E293B] mb-2">
                {step.title}
              </h3>
              <p className="text-[#64748B] text-sm">
                {step.description}
              </p>
            </motion.div>
          ))}
        </div>

        {/* Bottom note */}
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="text-center text-[#64748B] text-base"
        >
          It's that easy — your team could be{' '}
          <span className="text-[#1E293B] font-semibold">fully operational in minutes.</span>
        </motion.p>
      </div>
    </section>
  );
};
